import { render, staticRenderFns } from "./PlanejamentoAcaoFormAnexoArquivoNovo.vue?vue&type=template&id=bd1d5018&scoped=true&"
import script from "./PlanejamentoAcaoFormAnexoArquivoNovo.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoAcaoFormAnexoArquivoNovo.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoAcaoFormAnexoArquivoNovo.vue?vue&type=style&index=0&id=bd1d5018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1d5018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
